import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, GET_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE, UPDATE_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE, GET_DELEGATE_B2B_USER_ACTION_TYPE, getDelegate_All_B2b_MeetingListUrl, getDelegate_B2B_UsersUrl, UpdateDelegate_All_B2b_MeetingUrl } from "../../../utils/constants";


export const getDelegate_All_B2b_MeetingList_action = (MeetingDate, Status, CompanyName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            MeetingDate: MeetingDate,
            Status: Status,
            CompanyName: CompanyName
        }

        const res = await axiosGet(getDelegate_All_B2b_MeetingListUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegate_B2B_Users_action = (Designation, CompanyName, CountryName, Name) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            Designation: Designation,
            CompanyName: CompanyName,
            CountryName: CountryName,
            Name: Name,
        }

        const res = await axiosGet(getDelegate_B2B_UsersUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_B2B_USER_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const UpdateDelegate_All_B2b_Meeting_action = (B2BMeetingID, AdminRemark) => async (dispatch) => {
    try {
        const mapData = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            B2BMeetingID: B2BMeetingID,
            AdminRemark: AdminRemark,
        }

        const res = await axiosPost(UpdateDelegate_All_B2b_MeetingUrl, mapData, headers)

        dispatch({
            type: UPDATE_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
